const envTranslations = JSON.parse(process.env.REACT_APP_EN_TRANSLATIONS || '{}');

export const en = {
  translations: envTranslations,
};
